import React from "react";
import PageHeader from "../../../components/ui/page header/PageHeader";
import { useTranslation } from "react-i18next";
import AboutSection from "./components/aboutSection/AboutSection";

function AboutPage() {
  const { t } = useTranslation("about");

  return<>
    <PageHeader
      topic={t("pageHeader.topic")}
      topicSentence={t("pageHeader.topicSentence")}
    />
    <AboutSection/>
  </>;
}

export default AboutPage;
